var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_32569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0384521H50V37.5385H0V0.0384521Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 0.0384521L24.9219 14.1791L43.9062 0.0384521H50V4.8822L31.25 18.8666L50 32.7728V37.5385H43.75L25 23.5541L6.32812 37.5385H0V32.851L18.6719 18.9447L0 5.03845V0.0384521H5.85938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.125 21.9916L50 34.4135V37.5385L28.8281 21.9916H33.125ZM18.75 23.5541L19.2188 26.2885L4.21875 37.5385H0L18.75 23.5541ZM50 0.0384521V0.272827L30.5469 14.9603L30.7031 11.5228L46.0938 0.0384521H50ZM0 0.0384521L18.6719 13.7885H13.9844L0 3.3197V0.0384521Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8281 0.0384521V37.5385H31.3281V0.0384521H18.8281ZM0 12.5385V25.0385H50V12.5385H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.1166V22.6166H50V15.1166H0ZM21.3281 0.0384521V37.5385H28.8281V0.0384521H21.3281Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_32569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 37.5,
    fill: "white",
    transform: "translate(0 0.0384521)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.5185a81d837667bbbf4b2a282ce2d0ac.svg";
export { ForwardRef as ReactComponent };